<mat-dialog-content>
  <h2>Recipients</h2>
  <p *ngIf="mode === 'task'">
    In discussions attached to tasks, recipients are notified of new messages.
    This discussion is also visible to all users with access to this task's
    space.
  </p>
  <mat-list>
    <ng-container *ngFor="let user of users">
      <mat-divider></mat-divider>

      <mat-list-item>
        <span matListItemTitle>{{ user.name }}</span>
        <span *ngIf="assignedTo === user._id">Assigned to this task</span>
        <button
          *ngIf="authUserId === user._id && assignedTo !== user._id"
          mat-raised-button
          matListItemMeta
          (click)="leave()"
          color="warn"
        >
          Leave
        </button>
        <mat-divider></mat-divider>
      </mat-list-item>
    </ng-container>

    <mat-divider></mat-divider>
  </mat-list>

  <div class="search-field">
    <mat-form-field>
      <mat-label>
        {{ this.viewOnly ? 'You are no longer in this thread' : 'Add users' }}
      </mat-label>
      <input
        matInput
        [matAutocomplete]="userAutocomplete"
        [formControl]="selectUserControl"
        [disabled]="viewOnly"
      />
      <mat-autocomplete
        autoActiveFirstOption
        hideSingleSelectionIndicator
        (optionSelected)="addUser($event.option.value)"
        #userAutocomplete="matAutocomplete"
      >
        <mat-option
          disabled
          *ngIf="
            filteredUsers.length === 0 &&
            existingFilteredUsers.length === 0 &&
            notInSpaceFilteredUsers.length === 0
          "
        >
          No matching users.
        </mat-option>

        <mat-option
          class="user-option"
          *ngFor="let user of filteredUsers"
          [value]="user._id"
        >
          <div class="positioner">
            <div></div>
            <div class="name">
              {{ user.name }}
            </div>
            <button mat-stroked-button><mat-icon>add</mat-icon>Add</button>
          </div>
        </mat-option>

        <mat-option
          disabled
          class="user-option"
          *ngFor="let user of existingFilteredUsers"
          [value]="user._id"
        >
          <div class="positioner">
            <div><mat-icon>done</mat-icon></div>
            <div class="name">
              {{ user.name }}
            </div>
            <div></div>
          </div>
        </mat-option>

        <mat-option
          disabled
          class="user-option"
          *ngFor="let user of notInSpaceFilteredUsers"
          [value]="user._id"
        >
          <div class="positioner">
            <div></div>
            <div class="name">{{ user.name }} (not in space)</div>
            <div></div>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Close</button>
</mat-dialog-actions>
